const topics = [
  { name: '动作大片', count: '328部', icon: 'ri-sword-line', color: 'primary' },
  { name: '爱情喜剧', count: '256部', icon: 'ri-heart-line', color: 'accent' },
  { name: '悬疑推理', count: '189部', icon: 'ri-search-eye-line', color: 'secondary' },
  { name: '科幻冒险', count: '215部', icon: 'ri-rocket-line', color: 'primary' },
  { name: '恐怖惊悚', count: '142部', icon: 'ri-ghost-line', color: 'accent' },
  { name: '古装武侠', count: '178部', icon: 'ri-sword-fill', color: 'secondary' },
  { name: '动画动漫', count: '310部', icon: 'ri-emotion-line', color: 'primary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影视专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类型快速浏览，找到您最爱的影视专题分类
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
          {topics.map((topic, i) => {
            const colorMap: Record<string, string> = {
              primary: 'bg-primary-50 text-primary-700 group-hover:bg-primary-100',
              accent: 'bg-accent-50 text-accent-700 group-hover:bg-accent-100',
              secondary: 'bg-secondary-50 text-secondary-700 group-hover:bg-secondary-100',
            };
            return (
              <a
                key={i}
                href="#media"
                className={`flex flex-col items-center gap-3 p-5 rounded-xl transition-colors cursor-pointer group ${colorMap[topic.color]}`}
              >
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className={`${topic.icon} text-2xl`}></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
                <span className="text-xs opacity-70">{topic.count}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}